import React, { useEffect, useState } from 'react';

import { useI18n } from 'i18n/I18nContext';
import trackEvent from 'utils/trackEvent';

export interface StickyMobileCtaProps {
  /** Element that marks the end of the hero CTA; bar shows after this leaves view */
  showAfterId: string;
  /** Element near the page bottom; bar hides when this enters view */
  hideNearId: string;
}

const StickyMobileCta = ({ showAfterId, hideNearId }: StickyMobileCtaProps) => {
  const { t, localizePath, locale } = useI18n();
  const [pastHero, setPastHero] = useState(false);
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;

    const showEl = document.getElementById(showAfterId);
    const hideEl = document.getElementById(hideNearId);
    if (!showEl || !hideEl) return undefined;

    const showObserver = new IntersectionObserver(
      ([entry]) => {
        // Visible while hero CTA is still on screen; show sticky once it has scrolled away
        setPastHero(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    const hideObserver = new IntersectionObserver(
      ([entry]) => {
        setNearFooter(entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -20% 0px' }
    );

    showObserver.observe(showEl);
    hideObserver.observe(hideEl);

    return () => {
      showObserver.disconnect();
      hideObserver.disconnect();
    };
  }, [showAfterId, hideNearId]);

  const visible = pastHero && !nearFooter;

  return (
    <div
      className={`gb-sticky-cta lg:hidden ${visible ? 'gb-sticky-cta--visible' : ''}`.trim()}
      role="region"
      aria-label={t('home.stickyCtaLabel')}
      aria-hidden={!visible}
    >
      <div className="gb-sticky-cta__inner">
        <p className="gb-sticky-cta__hint m-0">{t('home.stickyCtaHint')}</p>
        <a
          href={localizePath('/onboard')}
          className="gb-btn gb-sticky-cta__button text-white text-base font-bold no-underline"
          tabIndex={visible ? 0 : -1}
          onClick={() => trackEvent('cta_click', { href: '/onboard', source: 'sticky', locale })}
        >
          {t('home.stickyCta')}
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCta;



// WEBPACK FOOTER //
// ./src/components/StickyMobileCta.tsx